module.exports = __webpack_public_path__ + "pk.svg?fbfb5582df374e123a0d4748380f406e";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/pk.svg
// module id = 1309
// module chunks = 0